import { useEffect } from 'react';
import { uniqBy } from 'lodash';
import { MODEL_YEAR_API_DEFAULT_VALUE } from '../../../utils/constants';
var getModelKey = function (item, detModelKey) {
    var _a, _b;
    if (detModelKey) {
        return (_b = (_a = item.model) === null || _a === void 0 ? void 0 : _a.detKey.value) !== null && _b !== void 0 ? _b : detModelKey;
    }
    return item.detModelKey.value;
};
var getModelYear = function (hasDetModelKey, itemParentGroup) {
    if (hasDetModelKey) {
        return itemParentGroup;
    }
    return MODEL_YEAR_API_DEFAULT_VALUE;
};
/**
 * Side Effect hook for syncing models IDs used for payment fetching
 *
 * @param {*} { items, detModelKey, itemParentGroup, setModels }
 */
var useSyncPaymentModels = function (_a) {
    var items = _a.items, detModelKey = _a.detModelKey, itemParentGroup = _a.itemParentGroup, setModels = _a.setModels;
    useEffect(function () {
        var models = items.map(function (trim) { return ({
            modelKey: getModelKey(trim, detModelKey),
            modelYear: getModelYear(!!detModelKey, itemParentGroup),
        }); });
        if (models)
            setModels(uniqBy(models, 'modelKey'));
        return function () {
            setModels([]);
        };
    }, [detModelKey, itemParentGroup]);
};
export default useSyncPaymentModels;
